angular.module('Itao.IndicatorMap').directive('bookmarkContainer', ['mapConfig', 'communeConfig', 'BookmarkService', 'ModalService', function(mapConfig, communeConfig, BookmarkService, ModalService) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'bookmarkContainer.html',
    scope: {
      'currentConfig': '=',
      'bookmarks': '=',
      'onBookmarkSelect': '&',
      'categories': '='
    },
    link: function(scope){
      if(!angular.isArray(scope.bookmarks)) {
        scope.bookmarks = [];
      }
      scope.selection = {};
      scope.selectableCategories = [];
      scope.showEditButtons = communeConfig.showEditOptions;
      scope.selectableCategories = [];

      scope.$watchCollection('bookmarks', function() {
        if(!scope.categories) return;
        scope.selectableCategories = scope.categories.filter(categorySelectFilter);
      });

      var categorySelectFilter = function(category) {
        if(!scope.bookmarks) return;
        return scope.bookmarks.filter(function (bookmark) {
            return bookmark && bookmark.category == category.id;
          }).length > 0;
      };

      /**
       * Creates a new bookmark. Opens a new modal window for data input
       */
      scope.addBookmark = function() {
        ModalService.createCustomModal({
          categories: scope.categories
        }, {
          templateUrl: mapConfig.templateBasePath + 'modals/bookmarkCreate.html',
          controller: 'BookmarkModalController'
        })
          .result
          .then(function(newBookmarkData) {
            return BookmarkService.createBookmark(newBookmarkData.title, newBookmarkData.categoryId, scope.currentConfig);
          })
          .then(function(newBookmark) {
            scope.bookmarks.push(newBookmark);
          })
          .catch(function(dismissReason) {
            console.log(dismissReason);
          });
      };

      /**
       * Deletes a given bookmark. Opens a new modal window for confirmation
       * @param {object} bookmark Bookmark object which should be deleted
       */
      scope.deleteBookmark = function(bookmark) {
        ModalService.createCustomModal({},
          {
            templateUrl: mapConfig.templateBasePath + 'modals/bookmarkDelete.html',
            controller: 'CustomModalController'
          })
          .result
          .then(function() {
            return BookmarkService.deleteBookmark(bookmark.id);
          })
          .then(function() {
            scope.bookmarks.splice(scope.bookmarks.indexOf(bookmark), 1);
          });
      };

      /**
       * Invokes the callbackFunction when a single bookmark gets selected
       * @param {object} bookmark Bookmark object which should be loaded
       */
      scope.loadBookmark = function(bookmark) {
        scope.onBookmarkSelect({
          bookmark: bookmark
        });
      };

    }
  };
}]);
